// src/components/Widgets/TinyBadgeWidget.jsx
import React from "react";

/**
 * Props:
 *  - status: string label, e.g. "OK", "Degraded", "Offline"
 *  - tone: "success" | "warn" | "error" | "info"
 *  - title: optional hover tooltip
 */
export default function TinyBadgeWidget({ status = "OK", tone = "success", title }) {
  const palette = {
    success: { base: "#22c55e" },
    warn:    { base: "#f59e0b" },
    error:   { base: "#ef4444" },
    info:    { base: "#3b82f6" },
  };
  const c = palette[tone] || palette.success;

  // Fallback if color-mix isn't supported
  const bg = `color-mix(in oklab, ${c.base} 20%, transparent)`;
  const bd = `color-mix(in oklab, ${c.base} 35%, black)`;

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="text-sm font-semibold">Studio Status</div>
      <span
        className="inline-flex items-center justify-center text-[10px] px-2 py-0.5 rounded-full"
        title={title || status}
        style={{
          background: bg.startsWith("color-mix") ? bg : c.base + "33",
          border: `1px solid ${bd.startsWith("color-mix") ? bd : c.base + "66"}`,
        }}
        aria-live="polite"
      >
        {status}
      </span>
    </div>
  );
}
